import { ensure, getFileExtension, getFileName, getFileNameWithExtension } from "sprint-common-web";
import { BucketObject } from "sprint-common-web/src/components/explorer/BucketObject";
import { BucketObjectType } from "sprint-common-web/src/components/explorer/types/BucketObjectType";

import { isMatchingFileExtension } from "../../../content-ingestion/common/isMatchingFileExtension";

export interface BucketInfoResponse {
    name: string;
    content: BucketObjectResponse[];
}

export enum BucketObjectTypeResponse {
    Folder,
    File
}

export type BucketObjectResponse = BucketFileObjectResponse | BucketFolderObjectResponse;

interface BucketObjectBaseResponse {
    path: string;
    parentPath: string;
    name: string;
}

export interface BucketFileObjectResponse extends BucketObjectBaseResponse {
    type: BucketObjectTypeResponse.File;
    sizeInBytes: number;
    lastModified: string;
}

export interface BucketFolderObjectResponse extends BucketObjectBaseResponse {
    type: BucketObjectTypeResponse.Folder;
    content: BucketObjectResponse[];
}

export const mapToBucketObject = (object: BucketObjectResponse): BucketObject => {
    if (object.type === BucketObjectTypeResponse.Folder) {
        return {
            id: getFileNameWithExtension(object.path),
            type: BucketObjectType.Folder,
            path: object.path,
            parentPath: object.parentPath,
            name: object.name,
            isSelectable: false
        };
    }

    const isFileValid = isValidFileObject(object);

    ensure(object.lastModified);

    return {
        id: getFileNameWithExtension(object.path),
        type: BucketObjectType.File,
        path: object.path,
        parentPath: object.parentPath,
        name: getFileNameWithExtension(object.path),
        sizeInBytes: object.sizeInBytes,
        lastModified: object.lastModified,
        isSelectable: isFileValid ? true : "File size or extension is invalid",
        isInactive: !isFileValid
    };
};

const isValidFileObject = (file: BucketFileObjectResponse): boolean =>
    file.sizeInBytes > 0 && isMatchingFileExtension(getFileExtension(file.path));
